import React from "react";
import ReactDOM from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import { QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { queryClient } from "./lib/queryClient";
import "./index.css";

// 셸 판별을 DOM에 고정 — CSS가 '뷰포트 폭'으로 웹/앱을 추정하던 것을 대체한다.
// (추정이 틀리는 지점이 iPad·태블릿: 폭이 넓다고 브라우저인 것은 아니다)
document.documentElement.dataset.shell =
  Capacitor.isNativePlatform() ? "native" : "web";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
